import React from "react";
import LcAccordion from "../../../../../components/Generic/LcAccordion";
import { SolicitationView } from "../../../../../models/SolicitationView";
import moment from "moment";
import "./index.css";

interface Props {
    solicitation: SolicitationView,
}

const SolicitationDetailsPropeties: React.FC<Props> = (props) => {
    const solicitation: SolicitationView = props.solicitation;

    const getPriority = (urgency: number): string => {
        const priorities: string[] = ["", "Normal", "Média", "Alta", "Crítica"];
        return priorities[urgency] || "";
    };

    return (
        <div className="divOrderDetailsProprieties">
            <LcAccordion title={"Propriedades"} visible={true} iconNormal={true}>
                <div className={"divAlignment"}>
                    <span className={"spanProprietiesNormalDetailsPropeties"}> Solicitação </span>
                    <span className={"spanProprietiesBold"}> {solicitation.id} </span>
                </div>

                <div className={"divAlignment"} style={{ marginBottom: (solicitation.nameBusinessArea.length > 40) ? "20" : "5px"}}>
                    <span className={"spanProprietiesNormalDetailsPropeties"}> Área de negócio </span>
                    <span className={"spanProprietiesBold"}> {solicitation.nameBusinessArea} </span>
                </div>

                <div className={"divAlignment"} style={{ marginBottom: (solicitation.nameServiceGroup.length > 40) ? "20px" : "5px" }}>
                    <span className={"spanProprietiesNormalDetailsPropeties"}> Grupo de serviço </span>
                    <span className={"spanProprietiesBold"} > {solicitation.nameServiceGroup} </span>
                </div>

                <div className={"divAlignment"} style={{ marginBottom: (solicitation.nameService.length > 35) ? "15px" : "5px" }}>
                    <span className={"spanProprietiesNormalDetailsPropeties"}> Serviço </span>
                    <span className={"spanProprietiesBold"} > {solicitation.nameService} </span>
                </div>

                <div className={"divAlignment"} style={{ margin: (solicitation.nameProcess.length > 40) ? "15px 0px" : "5px 0px" }}>
                    <span className={"spanProprietiesNormalDetailsPropeties"}> Processo </span>
                    <span className={"spanProprietiesBold"} > {solicitation.nameProcess} </span>
                </div>

                <div className={"divAlignment"} >
                    <span className={"spanProprietiesNormalDetailsPropeties"}> Data de solicitação </span>
                    <span className={"spanProprietiesBold"}> {moment(solicitation.solicitationDate).format("DD/MM/YYYY")} </span>
                </div>

                <div className={"divAlignment"} style={{ marginBottom: (solicitation.nameCustomer.length > 40) ? "20px" : "5px" }}>
                    <span className={"spanProprietiesNormalDetailsPropeties"}> Cliente </span>
                    <span className={"spanProprietiesBold"} > {solicitation.nameCustomer} </span>
                </div>

                <div className={"divAlignment"}>
                    <span className={"spanProprietiesNormalDetailsPropeties"}> Prioridade </span>
                    <span className={"spanProprietiesBold"}> {getPriority(solicitation.urgency)} </span>
                </div>
                {
                    props.solicitation.nameGroupSolicitation &&
                    <>
                        <div className={"divAlignment"}>
                            <span className={"spanProprietiesNormalDetailsPropeties"}> Grupo solicitante </span>
                            <span className={"spanProprietiesBold"}> {solicitation.nameGroupSolicitation} </span>
                        </div>
                        <div className={"divAlignment"}>
                            <span className={"spanProprietiesNormalDetailsPropeties"}> Solicitante </span>
                            <span className={"spanProprietiesBold"}> {solicitation.nameUserRequester} </span>
                        </div>
                    </>
                }
                {
                   solicitation.idClassification &&
                    <>
                        {   
                            solicitation.showSLAResponsetoRequester !== 0 &&
                             <div className={"divAlignment"}>
                                <span className={"spanProprietiesNormalDetailsPropeties"}> SLA de Resposta </span>
                                <span className={"spanProprietiesBold"}> {moment(solicitation.slaResponseDate).format("DD/MM/YYYY HH:MM")} </span>
                            </div>
                        }
                        {
                            solicitation.showSLASolutiontoRequester !== 0 &&
                            <div className={"divAlignment"}>
                                <span className={"spanProprietiesNormalDetailsPropeties"}> SLA de Conclusão </span>
                                <span className={"spanProprietiesBold"}> {moment(solicitation.slaSolutionDate).format("DD/MM/YYYY HH:MM")} </span>
                            </div>
                        }
                    </>
                }
            </LcAccordion>
        </div>
    );
};

export default SolicitationDetailsPropeties;